import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Loader2 } from "lucide-react";

export default function PoliciesConsultation() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/public/policies/consultation").then((r) => setD(r.data));
  }, []);
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-[#0B2B62] mb-6">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </Link>
        <div className="bg-white border border-slate-200 rounded-2xl p-8" data-testid="policies-consultation-page">
          <div className="flex items-center gap-2 mb-2">
            <ShieldCheck className="w-6 h-6 text-emerald-700" />
            <h1 className="font-display font-bold text-2xl text-[#0B2B62]">Política da Consulta RAF Direct</h1>
          </div>
          {!d ? (
            <div className="py-10 text-slate-500 text-center"><Loader2 className="w-5 h-5 animate-spin inline mr-2" />Carregando…</div>
          ) : (
            <>
              <p className="text-xs text-slate-500 mb-6">Versão <code className="bg-slate-100 px-1.5 py-0.5 rounded">{d.version}</code> · atualizada em {d.updated_at}</p>
              <h2 className="font-display font-bold text-[#0B2B62] text-lg mb-2">Em 1 minuto</h2>
              <ul className="list-disc pl-5 space-y-2 text-slate-700 mb-8">
                {d.summary.map((s, i) => <li key={i}>{s}</li>)}
              </ul>
              <h2 className="font-display font-bold text-[#0B2B62] text-lg mb-3">Detalhamento</h2>
              <div className="space-y-4">
                {Object.entries(d.sections).map(([k, v]) => (
                  <div key={k} className="border-l-4 border-emerald-500 pl-4 py-1">
                    <div className="text-[10px] uppercase tracking-widest text-emerald-800 font-bold mb-1">{k.replace(/_/g, " ")}</div>
                    <p className="text-slate-700 leading-relaxed">{v}</p>
                  </div>
                ))}
              </div>
              <div className="mt-8 pt-6 border-t border-slate-200 text-xs text-slate-500">
                Ao efetuar o pagamento no Stripe, a família declara ter lido e aceitado esta política. O consultor RAF registra o aceite no momento da reserva. Contato: <a href="mailto:contato@rafdirect.com.br" className="text-[#0B2B62] font-bold">contato@rafdirect.com.br</a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
